import { MED_RECEPTION_TABS } from "@/utils/constants";
import { filterObject } from "@/utils/helpers";
import { useAxios } from "@/utils/hooks/useAxios";
import { useSearchQuery } from "@/utils/hooks/useSearchQuery";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { produce } from "immer";
import { useTranslation } from "react-i18next";
import { useParams, useSearchParams } from "react-router";
import { toast } from "react-toastify";

export const useCreateBagMutation = (params) => {
    const { axiosProtected } = useAxios();
    const { t } = useTranslation();
    const queryClient = useQueryClient();
    const [searchParams] = useSearchParams();
    let date = searchParams.get("date") || "today";
    date = date.replace(MED_RECEPTION_TABS.all.key, "");
    date = date.replace(
        MED_RECEPTION_TABS.today.key,
        "/" + MED_RECEPTION_TABS.today.key
    );
    params = filterObject(params);

    return useMutation({
        mutationFn: ({ request_number, ...payload }) => axiosProtected.post(`madina/nusk-arrival-flights/${request_number}/bags`, payload),
        mutationKey: "createBag",
        onSuccess: (data, variables) => {
            toast.success(t("BAG_CREATED_SUCCESSFULLY"));
            queryClient.invalidateQueries({ queryKey: ["madina-arrivals"] });

            const newBag = data.data.data;
            queryClient.setQueryData(["one-bag", variables.request_number], (old) => {
                const payload = produce(old, (draft) => {
                    draft.data.data?.push(newBag);
                });


                return payload;
            });
        },
    });
};
export const useUpdateBagMutation = () => {
    const { axiosProtected } = useAxios();
    const [searchParams] = useSearchParams();
    let date = searchParams.get("date") || "today";
    date = date.replace(MED_RECEPTION_TABS.all.key, "");
    date = date.replace(
        MED_RECEPTION_TABS.today.key,
        "/" + MED_RECEPTION_TABS.today.key
    );

    return useMutation({
        mutationFn: ({ request_number, id, ...payload }) => axiosProtected.put(`madina/nusk-arrival-flights/${request_number}/bags/${id}`, payload),
        mutationKey: "updateBag"
    });
};

export const useGetBagsQuery = (params) => {
    const { axiosProtected } = useAxios();

    const { arrival_id } = params;
    return useQuery({
        queryKey: ["one-bag", arrival_id],
        queryFn: () => axiosProtected.get(`madina/nusk-arrival-flights/${arrival_id}/bags`),
        enabled: !!arrival_id,
    });
}
export const useGetBagByNumberQuery = ({ bag_number, enabled }) => {
    const { axiosProtected } = useAxios();

    return useQuery({
        queryKey: ["one-bag-by-number", bag_number],
        queryFn: () => axiosProtected.get(`madina/nusk-arrival-flights/bags/by_number/${bag_number}`),
        enabled
    });
}
export const useCreateAndAssignBagMutation = ({ manifestId }) => {
    const [searchParams] = useSearchQuery();
    const { axiosProtected } = useAxios();
    const { t } = useTranslation();
    const queryClient = useQueryClient();

    const source = searchParams?.source;
    const id = source === "between_cities" ? { tafweej_id: manifestId } : { manifest_id: manifestId };

    return useMutation({
        mutationFn: (payload) => axiosProtected.post(`madina/nusk-arrival-flights/bags`, { ...payload, ...id }),
        onSuccess: () => {
            toast.success(t("BAG_CREATED_SUCCESSFULLY"));
            queryClient.invalidateQueries({ queryKey: ["madina-manifests"] });
        },
    });
}

export const useUnassignBagMutation = () => {
    const { axiosProtected } = useAxios();
    const { t } = useTranslation();
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: ({ id, ...payload }) => axiosProtected.delete(`madina/reception/manifests/${id}/bag-number`, payload),
        onSuccess: () => {
            toast.success(t("BAG_UNASSIGNED_SUCCESSFULLY"));
            queryClient.invalidateQueries({ queryKey: ["madina-manifests"] });
        },
        onError: (error) => {
            toast.error(error.response.data.message);
        },
    });
}